import {

	DELETE_USER,
	UPDATE_USER,
	GET_USERS,
	CREATE_USER,
	GET_ERRORS,

	GET_CLIENT,
	CLIENT_LOADING,
	CLIENTS_LOADING,
	SET_MESSAGE
} from "../actions/types";

const initialState = {
	clients: [],
	client: [],
	error: [],
	total: 0,
	clientLoading: false,
	clientsLoading: false,

	actionType: ''
};

export default function (state = initialState, action) {
	switch (action.type) {
		case DELETE_USER:
			return {
				...state,
				actionType: action.type
			};
		case UPDATE_USER:
			return {
				...state,
				actionType: action.type,
			};
		case GET_USERS:
			return {
				...state,
				actionType: action.type,
				clients: action.payload.result.users,
				total: action.payload.result.total
			};
		case CREATE_USER:
			return {
				...state,
				actionType: action.type,
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error: action.payload
			};

		//-------------LEGACY------------/
		case GET_CLIENT:
			return {
				...state,
				actionType: action.type,
				client: action.payload,
				CLIENTLoading: false
			};
		case CLIENT_LOADING:
			return {
				...state,
				actionType: action.type,
				clientLoading: true
			};
		case CLIENTS_LOADING:
			return {
				...state,
				actionType: action.type,
				clientsLoading: true
			};
		case SET_MESSAGE:
			return {
				...state,
				actionType: action.type,
				success: action.payload.message
			};

		default:
			return state;
	}
}
